import styled from 'styled-components'
import { Colors } from 'advenio-components'
import { STATUS_DIV, CHILDRENS_DIV } from '../../Constants'

export const ChildrenContainer = styled.div`
  width: ${({ teacher, virtual }) => teacher || virtual ? '100%' : '80%'};
  height: auto;
  margin-left: ${({ teacher, virtual }) => teacher || virtual ? '0px' : '50px'};
  margin-top: ${props => props.virtual ? '0px' : '30px'};
  border-radius: 5px;
  background-color: white;
  box-shadow: 0px 3px 10px 0px rgba(0,0,0, .15);

  @media (max-width: 763px) {
    width: 100%;
    margin-left: 0;
    overflow-y: auto;
    margin-top: 0;
    border-radius: 0;
  }
`
export const ChildrenDiv = styled.div`
  display: flex;
  background-color: white;
  width: 100%;
  height: 105px;
  border-bottom: solid 1px;
  border-bottom-color: #CCCCCC;
  opacity: ${props => props.type === 'Inactive' || props.type === 'Home' ? 0.6 : ''};
  background-color: ${props =>  props.isComingCheckout ? CHILDRENS_DIV['Checkout'] :  props.isCloud ? '#f0f9fe' : CHILDRENS_DIV[props.type]};
`
export const InfoDiv = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1;
  height: 100%;
`
export const InfoDivOverlay = styled.div`
  position: absolute;
  z-index: 10;
  display: flex;
  flex: 1;
  height: 100%;
  width: 100%;
  cursor: pointer;
`
export const Status = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  padding-right: 10px;
  padding-left: 10px;
  border: solid 2px;
  border-radius: 5px;
  ${({ activityStatus }) => {
    let borderColor = '#CCCCCC'
    let bgColor = '#CCCCCC'
    let color = '#9B9B9B'

    if (activityStatus === 'Activo') {
      borderColor = '#4A90E2'
      bgColor = ''
      color = '#4A90E2'
    }

    return `
      border-color: ${borderColor};
      background-color: ${bgColor};
      color: ${color};
    `
  }}

  @media (max-width: 763px) {
    margin-top: 5px;
    font-size: 15px;
  }
`
export const CheckoutPill = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-left: 10px;
  padding-right: 10px;
  padding-left: 10px;
  border: solid 2px;
  border-radius: 5px;
  ${({ activityStatus }) => {
    let borderColor = '#F92135'
    let bgColor = ''
    let color = '#F92135'

    if (activityStatus === 'Activo') {
      borderColor = '#4A90E2'
      bgColor = ''
      color = '#4A90E2'
    }

    return `
      border-color: ${borderColor};
      background-color: ${bgColor};
      color: ${color};
    `
  }}

  @media (max-width: 763px) {
    margin-top: 5px;
    font-size: 15px;
  }
`
export const IconsDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin-right: 8px;
`
export const NameDiv = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 763px) {
    font-size: 15px;
  }
`
export const InformationDiv = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 763px) {
    font-size: 15px;
  }
`
export const ProfileDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70px;
  cursor: pointer;
`
export const ProfileDivOverlay = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  width: 70px;
  cursor: pointer;
`
export const StatusDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5px;
  background-color: ${props =>  props.isCloud ? '#55ACEE' :  props.isComingCheckout ? CHILDRENS_DIV['Checkout'] : STATUS_DIV[props.type]};
`
export const Img = styled.img`
  @media (max-width: 763px) {
    width: 20px;
    height: 20px;
  }
`
export const ActionButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 30px;
  margin: 0 16px;
  cursor: pointer;
`
export const StudyProgramPill = styled.span`
  margin-top: 1px;
  margin-left: 8px;
  padding: 2px 8px;
  background-color: ${Colors.yellow300};
  border-radius: 20px;
  color: ${Colors.yellowText};
  font-size: 12px;
  font-weight: bold;
`
export const CenterBadge = styled.div`
  padding: 2px 8px;
  border-radius: 20px;
  color: #595130;
  background: #FFE68A;
  font-size: 12px;
  font-weight: bold;
  margin-top: 5px;
`



// WEBPACK FOOTER //
// ./src/Components/ChildrenList/ChildrenList.styles.jsx